<template>
  <div class="public-container bg-dark-nvx">
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" style="display: none;">
      <defs>
        <g id="invoxia-logo">
          <path
              fill="#FFFFFF"
              d="M294.1,34.4c-27.2,0.1-45.2,19.1-45,47.4c0.3,23.2,20.8,42.8,45.2,42.5c29-0.3,45-22.5,45.3-42.9
					C340.1,53.3,321.2,34.3,294.1,34.4z M294.3,107.8c-16.6,0-28.4-12.1-28.4-29c0-16.2,11.9-27.9,28.3-28
					c16.3-0.1,28.4,11.8,28.4,27.9C322.6,95.7,310.9,107.8,294.3,107.8z"
          />
          <path
              fill="#FFFFFF"
              d="M97.8,34.4c-27.3,0.1-45.2,19.1-45,47.4V122h16.8V78.8c0-16.2,11.9-28,28.3-28.1
					c16.3-0.1,28.4,11.8,28.4,27.9V122l17-0.1l0-40.5C143.8,53.3,124.9,34.3,97.8,34.4z"
          />
          <ellipse fill="#FFFFFF" cx="23.8" cy="10.9" rx="11.6" ry="10.9"/>
          <ellipse fill="#FFFFFF" cx="459.7" cy="10.9" rx="11.6" ry="10.9"/>
          <path
              fill="#FFFFFF"
              d="M220.9,38.8l-25.1,61.9l-25.1-61.9c-0.6-1.6-2.1-2.6-3.8-2.6h-14.7l34.6,83.7c0.6,1.5,2.1,2.5,3.8,2.5H201
					c1.7,0,3.2-1,3.8-2.5l34.6-83.7h-14.7C223,36.2,221.5,37.2,220.9,38.8z"
          />
          <path
              fill="#FFFFFF"
              d="M16.3,36.4H0v16h16v69.8c5.5,0,10.7,0,16,0c0-16.1,0-50.1,0-70.2C31.9,43.4,24.9,36.4,16.3,36.4z"
          />
          <path
              fill="#FFFFFF"
              d="M580.9,36.6h-16.6v11.1c-16.5-18.5-44.6-16.2-59.6-2.4c-18.7,17.2-19.4,46.5-1.8,66
					c7.7,8.5,17.9,12.3,29.1,12.9c11.4,0.6,21.3-2.8,29.8-11.2c2.5,5.7,8.4,9.6,14.9,9.6c1,0,20,0,20,0v-16h-15.8V36.6z M535.7,107.7
					c-16.2-0.1-28-12.3-28-29.1c0-15.9,12.1-27.9,28.2-27.8c16.4,0.1,28.6,12.3,28.6,28.6C564.4,95.7,552.2,107.8,535.7,107.7z"
          />
          <path
              fill="#FFFFFF"
              d="M425.1,41.8l3.9-5.4h-9.4v0.1h-7.2c-2.3,0-4.4,1.1-5.7,2.9l-15.45,21.625L375.8,39.4
					c-1.3-1.8-3.4-2.9-5.7-2.9h-7.2v-0.1h-9.4l3.9,5.4l23.835,33.242L347.4,122.4h6.6c0.1,0,0.1,0,0.1,0l11.2-0.1
					c1.3,0,2.5-0.6,3.3-1.7l22.65-31.59l22.65,31.59c0.8,1.1,2,1.7,3.3,1.7l11.2,0.1c0,0,0,0,0.1,0h6.6l-33.835-47.358L425.1,41.8z"
          />
          <rect x="451.854" y="36.24" fill="#FFFFFF" width="15.904" height="85.726"/>
        </g>
      </defs>
    </svg>
    <header class="header-public bg-dark-nvx">
      <svg viewBox="0 0 596.9 124.2">
          <defs>
            <linearGradient
                id="logo_gradient_H"
                gradientUnits="objectBoundingBox"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="200%"
            >
              <stop stop-color="#47d7ac" offset="0.5"/>
              <stop stop-color="#FFFFFF" offset="0.5"/>
            </linearGradient>
            <linearGradient
                id="logo_gradient_M"
                gradientUnits="objectBoundingBox"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="200%"
            >
              <stop stop-color="#ff7f41" offset="0.5"/>
              <stop stop-color="#FFFFFF" offset="0.5"/>
            </linearGradient>
            <linearGradient
                id="logo_gradient_D"
                gradientUnits="objectBoundingBox"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="200%"
            >
              <stop stop-color="#ffbe00" offset="0.5"/>
              <stop stop-color="#FFFFFF" offset="0.5"/>
            </linearGradient>
          </defs>
          <use xlink:href="#invoxia-logo" class="logo_i"/>
      </svg>
    </header>
    <div class="d-flex container-global">
      <div v-if="last_position.datetime" class="pub-info col-lg-3 col-xl-2 bg-dark-nvx">
        <h3 class="title mb-4 d-lg-block d-none">Tracker Information</h3>
        <div class="d-flex mb-1">
          <span class="gray d-lg-block d-none">Name: </span>
          <span class="name">{{ last_position.name }}</span>
        </div>
        <div class="d-lg-flex d-none mb-1">
          <span class="gray">Serial: </span>
          <span>{{ last_position.serial }}</span>
        </div>
        <div class="d-lg-flex d-none mb-1">
          <span class="gray">{{$t('Last_Position')}}:</span>
          <span>{{last_position.lat|roundFloat(5)}}, {{last_position.lng|roundFloat(5)}}</span>
        </div>
        <div class="d-lg-flex d-none">
          <span class="gray">Last ping:</span>
          <span>{{last_position.datetime|formatTime}}</span>
        </div>
        <div class="separator my-4"></div>
        
        
        <div class="history" v-if="title_range">
          <a class="" @click="prev_period()" v-show="show_left">
            <img src="/images/left-arrow.png" width="32" height="32"/>
          </a>
          <div id="title_range" v-show="title_range">
            <span>{{title_range}}</span>
          </div>
          <a v-bind:class="{show : show_right}" class="show-chevron" @click="next_period()" >
            <img src="/images/right-arrow.png" width="32" height="32"/>
          </a>
        </div>
        <p class="credit">&copy; Invoxia {{currentYear}}</p>
      </div>
      
      <div class="col-sm-12 col-md-12 col-lg-9 col-xl-10 map-container">
        <div id="pub_map"></div>
        <div id="over_map" v-show="error">
          <h2 class="text-center">{{$t('pub_link_error')}}</h2>
        </div>
      </div>
    </div>
  </div>
  
</template>

<style lang="scss" scoped>
@import "../assets/scss/style.scss";

.show-chevron {
  visibility: hidden;
}
.history {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  img {
    width: 30px;
    height: 30px;
  }
}
.pub-info {
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 500;
    margin: auto;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    padding: 1rem;
    width: 80%;
  }
}
.show {
  visibility: visible;
}
.separator {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.37);
}
.credit {
  margin-top: auto;
  margin-bottom: 0;
}
.gray {
  opacity: .5;
  margin-right: auto;
}
.title {
  text-transform: uppercase;
  line-height: 1.3;
}

.public-container {
  color: white;
  @media screen and (min-width: 900px) {
    height: 100vh;
  }
}
.container-global {
  position: relative;
}
@media screen and (max-width: 400px) {
  #pub_map {
    max-width: 100%;
    min-width: 350px;
  }
}
@media screen and (max-width: 768px) {
  .map-container {
    padding: 0 !important;
  }
  .name {
    text-align: center;
    width: 100%;
    font-size: 1.7rem;
  }
  .separator {
    margin: 0.5rem 0 !important;
  }
}

@media screen and (min-width: 450px) {
  #pub_map {
    min-width: 100%;
    height: 94vh;
  }
}

button:focus {
  outline: none !important;
}

.header-public {
  padding: 0.5rem 1rem;
  border-bottom: 1px white solid;
  svg {
    width: 108px;
    margin-left: 9px;
    margin-right: 9px;
    width: 108px;
    padding: 0.3125rem 0;
  }
}
</style>

<script>
var map = null;
var infoWindow = null;
let moment = require('moment');

function initMap(info) {
  if (map == null) {
    map = new google.maps.Map(document.getElementById('pub_map'), {
      zoom: 14,
      scaleControl: true,
      streetViewControl: true,
      center: {lat: info.lat, lng: info.lng}
    });
  }
}

import {PUB_HTTP} from '../http-constants'
import gmapsInit from "../gmaps";

export default {
  data() {
    return {
      error: false,
      last_position: {},
      token: null,
      title_range: null,
      date_start: null,
      date_end: null,
      history: [],
      routePath: null,
      markers: [],
      currentYear: new Date().getFullYear()
    }
  },
  delimiters: ['${', '}'],
  computed: {
    show_left() {
      if (!this.title_range){
        return false;
      }
      return true;
    },
    show_right() {
      if (!this.title_range) {
        return false;
      }
      if (this.date_end > moment()){
        return false;
      }
      return true;
    },
  },
  methods: {
    'loadLastMap': function () {
      let self = this;
      self.error = false;
      PUB_HTTP.get('/pub/trackers/' + self.token + '/',)
      .then(function (re) {
        self.last_position = re.data;
        initMap(self.last_position);
        self.setLastMarker(map, self.last_position);
        if (self.last_position.mode != 'single') {
          self.get_history();
        }
      })
      .catch(function (error) {
        console.log(error);
        self.error = true;
      });
    },
    get_history() {
      let self = this;
      self.title_range = self.date_range_title();
      let params = "?date_start=" + self.date_start.toISOString();
      params += "&date_end="+self.date_end.toISOString();
      
      self.clearMap();
      PUB_HTTP.get('/pub/trackers/' + self.token + '/history/' + params,)
      .then(function (re) {
        self.history = re.data;
        if (self.history.length) {
          self.setHistoryMarkers(map, self.history, true);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    setLastMarker(map, info) {
      let self=this;
      let marker = new google.maps.Marker({
        position: {lat: info.lat, lng: info.lng},
        map: map,
        title: info.name
      });
      self.markers.push(marker);
    },
    history_marker_title(position, full_date) {
      let _count = position["count"];
      let date1 = moment(position["date_start"]);
      
      let _format = "HH:mm";
      if (full_date) {
        _format = "LLL";
      }
      var _info = date1.format(_format);
      if (_count > 1) {
        let date2 = moment(position["date_end"]);
        _info += "-" + date2.format(_format);
      }
      return _info;
    },
    history_marker_info(position, full_date) {
      var _count = position["count"];
      var date1 = moment(position["date_start"]);
      console.log(date1);
      
      var _format = "HH:mm";
      if (full_date) {
        _format = "LLL";
      }
      var _info = date1.format(_format);
      if (_count > 1) {
        var date2 = moment(position["date_end"]);
        _info += "-" + date2.format(_format);
      }
      if (_count > 1) {
        _info += "<br>" + _count + " positions";
      }
      return _info;
    },
    clearMap() {
      let self = this;
      if (self.routePath != null) {
        self.routePath.setMap(null);
        self.routePath = null;
      }
      if (infoWindow) {
        infoWindow.close();
      }
      for (let i = 0; i < self.markers.length; i++) {
        self.markers[i].setMap(null);
      }
      self.markers = [];
    },
    next_period() {
      let _diff = Math.max(1, this.date_end.diff(this.date_start, "days"));
      this.date_start = this.date_start.add(_diff, "days");
      this.date_end = this.date_end.add(_diff, "days");
      this.title_range = this.date_range_title();
      this.get_history();
    },
    prev_period() {
      let _diff = Math.max(1, this.date_end.diff(this.date_start, "days"));
      this.date_start = this.date_start.subtract(_diff, "days");
      this.date_end = this.date_end.subtract(_diff, "days");
      this.title_range = this.date_range_title();
      this.get_history();
    },
    date_range_title() {
      if (this.date_start == "") {
        return "...";
      }
      
      let _diff = this.date_end.diff(this.date_start, "hours");
      let _title = this.date_start.format("dddd Do MMMM");
      if (_diff > 24) {
        _title += " - " + this.date_end.format("dddd Do MMMM");
      }
      return _title;
    },
    setHistoryMarkers(map, positions, resize) {
      let self = this;
      var bounds = new google.maps.LatLngBounds();
      var coordinates = [];
      
      var full_date = false;
      var _diff = self.date_end.diff(self.date_start, "hours");
      if (_diff > 24) {
        full_date = true;
      }
      
      for (let i = 0; i < positions.length; i++) {
        let position = positions[i];
        let point = {lat: position.lat, lng: position.lng};
        bounds.extend(point);
        coordinates.push(point);
        
        let marker = new google.maps.Marker({
          position: {lat: position.lat, lng: position.lng},
          map: map,
          title: self.history_marker_title(position, full_date),
          zIndex: 999
        });
        
        let scale = 1;
        const date_start = Date.parse(position.date_start);
        const date_end = Date.parse(position.date_end);
        
        let _diff = (date_end - date_start) / 1000 / 60;
        if (position.count > 1 && _diff > 2) {
          scale = 1.5;
        }
        if (i == positions.length - 1) {
          let icon = {
            url: "/js/gmaps/" + "flag.png",
            scaledSize: new google.maps.Size(32 * scale, 32 * scale),
            anchor: new google.maps.Point(16 * scale, 24 * scale)
          };
          marker.setIcon(icon);
        } else {
          var size = scale * 10;
          let icon = {
            url: "/js/gmaps/" + "smallplace.png",
            scaledSize: new google.maps.Size(size * 2, size * 2),
            anchor: new google.maps.Point(size, size)
          };
          marker.setIcon(icon);
        }
        
        self.markers.push(marker);
        // Allow each marker to have an info window
        google.maps.event.addListener(
        marker,
        "click",
        (function (marker, i) {
          return function () {
            var position = positions[i];
            var full_date = false;
            var _diff = self.date_end.diff(self.date_start, "hours");
            if (_diff > 24) {
              full_date = true;
            }
            var _title = self.history_marker_info(position, full_date);
            if (infoWindow) {
              infoWindow.close();
            }
            infoWindow = new google.maps.InfoWindow();
            infoWindow.setContent(_title);
            infoWindow.open(map, marker);
          };
        })(marker, i)
        );
      }
      
      if (resize && positions.length) {
        google.maps.event.addListenerOnce(map, "bounds_changed", function () {
          this.setZoom(Math.min(15, this.getZoom()));
        });
        map.fitBounds(bounds);
      }
      self.routePath = new google.maps.Polyline({
        path: coordinates,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2
      });
      
      self.routePath.setMap(map);
    }
  },
  async mounted() {
    const google = await gmapsInit();
    
    let parameters = this.$route.query;
    console.log(parameters)
    this.token = parameters['token']
    
    this.date_start = moment().startOf('day');
    this.date_end = moment().endOf('day');
    this.loadLastMap();
  }
}
</script>